import {
  Component,
  OnInit,
  OnDestroy,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { PeriodSelection } from './period-selection.enum';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subject } from 'rxjs';
import { Moment } from 'moment';
import { takeUntil } from 'rxjs/operators';
import { MatDatepickerInputEvent, MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { Period } from './period';
import { ITime } from '../time-control/w-clock/w-clock.component';
import { NgIf } from '@angular/common';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatFormField, MatSuffix, MatLabel } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MatInput } from '@angular/material/input';
import { WMatTimePickerComponent } from '../time-control/w-mat-timepicker/w-mat-timepicker.component';

@Component({
    selector: 'pcp-period-selection',
    templateUrl: './period-selection.component.html',
    styleUrls: ['./period-selection.component.scss'],
    imports: [NgIf, FlexModule, MatFormField, MatSelect, MatOption, MatInput, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatLabel, MatDatepicker, WMatTimePickerComponent]
})
export class PeriodSelectionComponent implements OnInit, OnDestroy {
  constructor(breakpointObserver: BreakpointObserver) {
    breakpointObserver
      .observe([Breakpoints.HandsetLandscape, Breakpoints.HandsetPortrait])
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((result) => {
        if (result.matches) {
          this.isHandset = true;
        } else {
          this.isHandset = false;
        }
      });
  }

  public onDestroy$ = new Subject<void>();
  public isHandset = false;
  public periodSelection = PeriodSelection;
  @Output() public valueChange = new EventEmitter<Period>();
  @Input() value: Period | null = null;
  ngOnInit() {}

  ngOnDestroy() {
    this.onDestroy$.next();
  }

  setTime(time: ITime, date: Date) {
    if (!this.value) {
      this.value = new Period();
    }
    return new Date(date.setHours(time.hour, time.minute));
  }

  valueChanged(value: PeriodSelection) {
    if (!this.value) {
      this.value = new Period();
    }
    this.value.period = value;
    this.valueChange.emit(this.value);
  }

  userTimeChanged(time: ITime, isFromTime: boolean) {
    let origValue = this.value;
    if (!origValue) {
      origValue = new Period();
    }

    const newVal = new Period();
    newVal.period = origValue.period;
    newVal.fromDate = origValue.fromDate;
    newVal.toDate = origValue.toDate;
    newVal.fromTime = origValue.fromTime;
    newVal.toTime = origValue.toTime;
    if (isFromTime) {
      newVal.fromTime = time;
      newVal.fromDate = this.setTime(newVal.fromTime, newVal.fromDate);
    } else {
      newVal.toTime = time;
      newVal.toDate = this.setTime(newVal.toTime, newVal.toDate);
    }
    this.value = newVal;
    this.valueChange.emit(this.value);
  }

  dateChange(event: MatDatepickerInputEvent<Date>, isFrom: boolean) {
    const momentValue = event.value;
    if (!momentValue) {
      return;
    }
    let origValue = this.value;
    if (!origValue) {
      origValue = new Period();
    }
    const value = momentValue;
    const newVal = new Period();
    newVal.period = origValue.period;
    newVal.fromDate = origValue.fromDate;
    newVal.toDate = origValue.toDate;
    newVal.fromTime = origValue.fromTime;
    newVal.toTime = origValue.toTime;
    if (isFrom) {
      newVal.fromDate = value;
      newVal.fromTime = origValue.fromTime;
    } else {
      newVal.toDate = value;
      newVal.toTime = origValue.toTime;
    }
    this.value = newVal;
    this.valueChange.emit(this.value);
  }
}
